import React from 'react';
import PropTypes from 'prop-types';
// material
import { Paper, Typography } from '@mui/material';

// ----------------------------------------------------------------------

export default function SearchNotFound({ searchQuery = '', ...other }) {
  return (
    <Paper sx={{ p: 5 }} {...other}>
      <Typography gutterBottom align="center" variant="subtitle1">
        {searchQuery ? `No results found for "${searchQuery}"` : 'No results found'}
      </Typography>
    </Paper>
  );
}

SearchNotFound.propTypes = {
  searchQuery: PropTypes.string,
};

SearchNotFound.defaultProps = {
  searchQuery: '',
};
